import { CREATE_SPIN_GAME, CREATE_SPIN_GAME_SUCCESS, CREATE_SPIN_GAME_ERROR, CREATE_SPIN_GAME_EMPTY } from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateSpinGame = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_SPIN_GAME:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_SPIN_GAME_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case CREATE_SPIN_GAME_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_SPIN_GAME_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateSpinGame;
